"use strict";
// @generated by protoc-gen-connect-es v1.4.0 with parameter "target=ts,import_extension=none"
// @generated from file spwn/account/v1/authop_service.proto (package spwn.account.v1, syntax proto3)
/* eslint-disable */
// @ts-nocheck
Object.defineProperty(exports, "__esModule", { value: true });
exports.AuthopAccountService = void 0;
const authop_service_pb_1 = require("./authop_service_pb");
const protobuf_1 = require("@bufbuild/protobuf");
/**
 * OIDC Provider (auth-op) 向けのサービス
 *
 * auth-op は SPWN ID で外部サービスにログインさせるための OpenID Provider。
 * idToken は SPWN backend の API を叩ける資格情報でもあるため auth-op には渡さず、
 * backend が発行した一回限りのコードを経由してユーザーを特定する。
 *
 *   accounts.spwn.jp (ログイン画面)   --- idToken ---> backend  ... コードを発行
 *   accounts.spwn.jp                  --- コード ---> auth-op
 *   auth-op                           --- コード ---> backend   ... uid / email と引き換え
 *
 * @generated from service spwn.account.v1.AuthopAccountService
 */
exports.AuthopAccountService = {
    typeName: "spwn.account.v1.AuthopAccountService",
    methods: {
        /**
         * 一回限りのコードを uid / email と引き換える
         *
         * コードは引き換えと同時に消費されるため、2回目の呼び出しは失敗する。
         *
         * @generated from rpc spwn.account.v1.AuthopAccountService.ExchangeOidcLoginCode
         */
        exchangeOidcLoginCode: {
            name: "ExchangeOidcLoginCode",
            I: authop_service_pb_1.AuthopAccountServiceExchangeOidcLoginCodeRequest,
            O: authop_service_pb_1.AuthopAccountServiceExchangeOidcLoginCodeResponse,
            kind: protobuf_1.MethodKind.Unary,
        },
        /**
         * auth-op が持っているセッションを使い続けてよいかを確かめる
         *
         * auth-op のセッションは SPWN 側のログアウト・退会・凍結を知らないため、
         * 放置すると SPWN からログアウトした利用者が無操作で外部サービスへ入れてしまう。
         * 認可のたびに呼ぶ（`/oidc/token` は RP のタイムアウト制約があるため呼ばない）。
         *
         * 退会・メール未検証は NOT_FOUND、判定できなければ UNAVAILABLE で返す。
         * auth-op は前者でだけ Grant を捨てる。一時的な障害で捨てると、復旧しても
         * 踏んだ人全員が再ログインからやり直しになるため。
         * 凍結は OK + disabled で返す。
         *
         * @generated from rpc spwn.account.v1.AuthopAccountService.GetAccountState
         */
        getAccountState: {
            name: "GetAccountState",
            I: authop_service_pb_1.AuthopAccountServiceGetAccountStateRequest,
            O: authop_service_pb_1.AuthopAccountServiceGetAccountStateResponse,
            kind: protobuf_1.MethodKind.Unary,
        },
    }
};
//# sourceMappingURL=authop_service_connect.js.map